import e from"react";import t from"../../../../RichTextRenderer/RichTextRenderer.js";import{Description as r}from"./styles.js";const i=({testId:i,description:o})=>o?e.createElement(r,{"data-testid":i},e.createElement(t,{text:o})):null;export{i as Description};
//# sourceMappingURL=index.js.map
